import { CLEAR_SEARCH_INPUT, GET_SEARCH_INPUT } from "./types";
export const getSearchInputSuccess = (value) => ({
    type: GET_SEARCH_INPUT,
    payload: value,
});
export const clearSearchInputSuccess = () => ({
    type: CLEAR_SEARCH_INPUT,
});
